import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { getTabBarItems } from '../../utils/helpers/getTabBarItems';
import { TabBarItem } from './TabBarItem';
import { ICustomTabBarItem } from './types';
import { TabBarContainer, TabBarWrapper, TabBarList } from './styled';
import useScreenSize from '../../hooks/useScreenSize';
import { useClient } from '../../hooks/useClient';
import { useHideTabBarOnKeyboardOpen } from '../../hooks/useHideTabBarOnKeyboardOpen';

const TabBarNavigationComponent: React.FC<{ isAuthInProgress: boolean }> = ({
  isAuthInProgress
}) => {
  const { t } = useTranslation();
  const { isSmall } = useScreenSize();
  const isClient = useClient();

  const tabBarItems: ICustomTabBarItem[] = getTabBarItems(t);
  const shouldHideTabBar = useHideTabBarOnKeyboardOpen();

  if (isClient && !isSmall) return null;

  return (
    <TabBarContainer $isHidden={shouldHideTabBar}>
      <TabBarWrapper>
        <TabBarList>
          {tabBarItems.map((item, i) => (
            <TabBarItem
              key={`item_${i}`}
              item={item}
              isAuthInProgress={isAuthInProgress}
            />
          ))}
        </TabBarList>
      </TabBarWrapper>
    </TabBarContainer>
  );
};

export const TabBarNavigation = memo(TabBarNavigationComponent);
